const _createAPIType = (_prefix) => ({
  START: `${_prefix}_API_START`,
  SUCCESS: `${_prefix}_API_SUCCESS`,
  ERROR: `${_prefix}_API_ERROR`,
  GROUP: `${_prefix}_API`,
});

const ActionTypes = {
  admin: {
    getAllScorecards: _createAPIType('GET_ADMIN_SCORECARDS'),
    getTalentScorecard: _createAPIType('GET_TALENT_SCORECARD'),
    getTalentScorecardValues: _createAPIType('GET_TALENT_SCORECARD_VALUES'),
    patchTalentScorecard: _createAPIType('PATCH_TALENT_SCORECARD'),
    talentFilters: _createAPIType('ADMIN_TALENT_FILTERS'),
    clearTalentFilters: 'CLEAR_ADMIN_TALENT_FILTERS',

    filters: {
      get: 'GET_ADMIN_FILTERS',
      add: 'ADD_ADMIN_FILTER',
      remove: 'REMOVE_ADMIN_FILTER',
      removeAll: 'REMOVE_ALL_ADMIN_FILTERS',
      removeInProgress: 'REMOVE_IN_PROGRESS_ADMIN_FILTERS',
    },
  },
  auth: {
    checkIfLoggedIn: _createAPIType('CHECK_STATUS'),
    checkIfAdmin: _createAPIType('CHECK_ADMIN'),
    signUp: _createAPIType('SIGN_UP'),
    logout: _createAPIType('AUTH_LOGOUT'),
    verifyAccount: _createAPIType('VERIFY_ACCOUNT'),
    refreshToken: 'AUTH_REFRESH_TOKEN',
    clearErrors: 'CLEAR_ERRORS',
    clear: 'CLEAR',
  },
  analytics: {
    trackView: _createAPIType('POST_TRACKING_VIEW'),
    trackPlay: _createAPIType('POST_TRACKING_PLAY'),
    changeUser: _createAPIType('CHANGE_USER'),
    logEvent: _createAPIType('LOG_EVENT'),
    setCustomAttribute: _createAPIType('SET_CUSTOM_ATTRIBUTE'),
    openSession: _createAPIType('OPEN_SESSION'),
  },
  trackingAction: {
    viewedProfile: _createAPIType('VIEWED_PROFILE'),
    viewedResponse: _createAPIType('VIEWED_RESPONSE'),
    viewedMyShot: _createAPIType('VIEWED_MYSHOT'),
  },
  profile: {
    get: _createAPIType('GET_PROFILE'),
    getResponses: _createAPIType('GET_PROFILE_RESPONSES'),
    patch: _createAPIType('PATCH_PROFILE'),
    putTalentNotes: _createAPIType('PUT_TALENT_NOTES'),
    clear: 'CLEAR',
  },
  company: {
    get: _createAPIType('GET_COMPANY'), // Get single company based on id
    post: _createAPIType('POST_COMPANY'),
    patch: _createAPIType('PATCH_COMPANY'),
    patchImage: _createAPIType('PATCH_COMPANY_IMAGE'),
    reset: 'RESET',
  },
  teamMember: {
    getUser: _createAPIType('GET_USER'),
    getInvite: _createAPIType('GET_INVITE'),
    post: _createAPIType('POST_INVITE'),
    patchInvite: _createAPIType('PATCH_INVITE'),
    patchUser: _createAPIType('PATCH_USER'),
    resendInvite: _createAPIType('RESEND_INVITE'),
    removeInvite: _createAPIType('REMOVE_INVITE'),
    clear: 'CLEAR_TEAM_MEMBER',
  },
  team: {
    get: _createAPIType('GET_TEAM_LIST'),
    removeUser: _createAPIType('REMOVE_TEAM_MEMBER'),
  },
  media: {
    clearVideo: 'CLEAR_VIDEO',
    clearImage: 'CLEAR_IMAGE',
    editMediaAsset: _createAPIType('EDIT_MEDIA_ASSET'),
    checkUploadStatus: _createAPIType('CHECK_UPLOAD_STATUS'),
    getPresignedUrl: _createAPIType('GET_PRESIGNED_URL'),
    uploadMediaAsset: _createAPIType('UPLOAD_MEDIA_ASSET'),
  },
  user: {
    init: _createAPIType('GET_USER_INIT'),
    getInfo: _createAPIType('GET_USER_INFO'),
    patch: _createAPIType('PATCH_USER_INFO'),
    clearPatch: 'CLEAR_PATCH',
    clear: 'CLEAR_USER',
  },
  discover: {
    get: _createAPIType('GET_DISCOVER'),
    getChannel: _createAPIType('GET_CHANNEL'),
    postFilters: _createAPIType('POST_DISCOVER_FILTERS'),
    clearPostFilters: 'CLEAR_POST_FILTERS',
  },
  watchlist: {
    get: _createAPIType('GET_WATCHLIST'),
    add: _createAPIType('ADD_TO_WATCHLIST'),
    remove: _createAPIType('REMOVE_FROM_WATCHLIST'),
    clearAdd: 'CLEAR_ADD_WATCHLIST',
    clearRemove: 'CLEAR_REMOVE_WATCHLIST',
  },
  statements: {
    getAll: _createAPIType('GET_STATEMENTS'),
    removeQuestion: _createAPIType('REMOVE_QUESTION'),
    patchedQuestion: 'PATCHED_QUESTION',
    clear: 'CLEAR_STATEMENT',
  },
  statementItem: {
    getQuestion: _createAPIType('GET_QUESTION'),
    postQuestion: _createAPIType('POST_QUESTION'),
    patchQuestion: _createAPIType('PATCH_QUESTION'),
    getQuestionResponses: _createAPIType('GET_QUESTION_RESPONSES'),
    clear: 'CLEAR_STATEMENT_ITEM',
  },
  job: {
    getAllJobs: _createAPIType('GET_JOBS'),
    removeJob: _createAPIType('REMOVE_JOB'),
    patchedJob: 'PATCHED_JOB',
    clearPatchedJob: 'CLEAR_PATCHED_JOB',
    clearRemoval: 'CLEAR_REMOVAL',
    clear: 'CLEAR_JOB',
  },
  jobItem: {
    getJob: _createAPIType('GET_JOB'),
    postJob: _createAPIType('POST_JOB'),
    patchJob: _createAPIType('PATCH_JOB'),
    archive: _createAPIType('PATCH_ARCHIVE'),
    clear: 'CLEAR_JOB_ITEM',
  },
  notifications: {
    add: _createAPIType('ADD_NOTIFICATION'),
    remove: 'REMOVE_NOTIFICATION',
    removeAll: 'REMOVE_ALL_NOTIFICATION',
  },
  filters: {
    get: 'GET_FILTERS',
    add: 'ADD_FILTER',
    remove: 'REMOVE_FILTER',
    removeAll: 'REMOVE_ALL_FILTERS',
    removeInProgress: 'REMOVE_IN_PROGRESS_FILTERS',
  },
  search: {
    getLocation: _createAPIType('GET_LOCATION'),
    getJobLocation: _createAPIType('GET_JOB_LOCATION'),
    getInterests: _createAPIType('GET_INTERESTS'),
    getGraduationYears: _createAPIType('GET_GRADUATION_YEARS'),
    getCharacterTraits: _createAPIType('GET_CHARACTER_TRAITS'),
    getCollegeLeague: _createAPIType('GET_COLLEGE_LEAGUE'),
    getCompanies: _createAPIType('GET_COMPANIES'),
    getCompanyQuestions: _createAPIType('GET_COMPANY_QUESTIONS'),
  },
  intake: {
    postIntakeSubmission: _createAPIType('POST_INTAKE_SUBMISSION'),
    clearIntake: 'CLEAR_INTAKE_SUBMISSION',
  },
  NIL: {
    getAll: _createAPIType('GET_NIL_LIST'),
    get: _createAPIType('GET_NIL'),
    post: _createAPIType('POST_NIL'),
    patch: _createAPIType('PATCH_NIL'),
    delete: _createAPIType('DELETE_NIL'),
    applications: {
      getAll: _createAPIType('GET_NIL_APPLICATIONS_LIST'),
    },
    clearUploads: 'CLEAR_UPLOADS',
  },
  originals: {
    getAll: _createAPIType('GET_ORIGINALS_LIST'),
    get: _createAPIType('GET_ORIGINAL'),
    post: _createAPIType('POST_ORIGINAL'),
    patch: _createAPIType('PATCH_ORIGINAL'),
    delete: _createAPIType('DELETE_ORIGINAL'),
    clearImageUploads: 'CLEAR_IMAGE_UPLOADS',
    clearVideoUploads: 'CLEAR_VIDEO_UPLOADS',
  },
};

export default ActionTypes;
